module.exports = __webpack_public_path__ + "assets/img/zpimg3.1b03d920.png";